module.exports = __webpack_public_path__ + "static/media/ic_product_active.6f830ba9.svg";